<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>連絡先グループ新規作成</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>グループ名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="group.groupName" class="form-control" autocomplete="off" placeholder="グループ名" required>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="isHierarchyGroupEnabled">
            <div class="row">
              <div class="col-3">
                <label>階層</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="group.hierarchyNo" v-on:change="selectHierarchy">
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group" v-show="isHierarchyGroupEnabled">
            <div class="row">
              <div class="col-3">
                <label>親グループ</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="group.parentId" :required="parentRequired">
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      name: 'group',
      message: '',
      groupOptions: [],
      parentRequired: false,
      group: {
        hospitalId: 0,
        extraContactId: 0,
        groupName: '',
        parentId: 0,
        hierarchyNo: 1
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isHierarchyGroupEnabled: function () {
      return this.$store.getters.contact.isHierarchyGroupEnabled
    }
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          this.group.hospitalId = this.$store.getters.hospital.id,
          this.group.extraContactId = this.$route.params.extraContactId
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup" 
                      : "/api/group/public"
          axios.post(url, {
              group: this.group
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
    },
    selectHierarchy() {
      this.getHierarchylist(this.group.hierarchyNo - 1)
    },
    getHierarchylist(hierarchyNo) {
      if(!this.$store.getters.contact.isHierarchyGroupEnabled) return
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var extraContactId = this.$route.params.extraContactId
          axios.post("/api/hierarchygroup/management/hierarchylist/", {
            hospitalId: hospitalId,
            extraContactId: extraContactId,
            hierarchyNo: hierarchyNo
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            this.groupOptions = response.data.data.groups
            if(this.groupOptions.length > 0) {
              this.group.parentId = this.groupOptions[0].id
              this.parentRequired = true
            } else if (Number(this.group.hierarchyNo) === 1) {
              this.group.parentId = 0
              this.parentRequired = false
            } else {
              this.group.parentId = 0
              this.parentRequired = true
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>